import { MapPin, Clock, Lock } from "lucide-react";
import { FaInstagram, FaFacebook, FaYoutube } from "react-icons/fa";
import { FaXTwitter } from "react-icons/fa6";

const LOGO_URL = "https://customer-assets.emergentagent.com/job_faith-bubbles-io/artifacts/j7evy55i_WINNERS%20LOGO%20REAL.png";

const socials = [
  { icon: FaInstagram, href: "https://www.instagram.com/winnerschapel_ipswich/", label: "Instagram" },
  { icon: FaFacebook, href: "https://www.facebook.com/share/1B41at1HyS/?mibextid=wwXIfr", label: "Facebook" },
  { icon: FaXTwitter, href: "https://x.com/wci_ipswich", label: "X" },
  { icon: FaYoutube, href: "https://www.youtube.com/", label: "YouTube" },
];

const quickLinks = [
  { label: "Home", href: "#home" },
  { label: "About Us", href: "#about" },
  { label: "Services", href: "#services" },
  { label: "Events", href: "#events" },
  { label: "Gallery", href: "#instagram" },
  { label: "Prayer Request", href: "#prayer" },
];

export const Footer = ({ onAdminClick }) => {
  const scrollTo = (href) => {
    const el = document.querySelector(href);
    if (el) el.scrollIntoView({ behavior: "smooth" });
  };

  return (
    <footer data-testid="footer" className="bg-stone-900 text-white relative overflow-hidden">
      <div className="bubble-decoration bg-red-600 w-64 h-64 -top-32 -left-32 opacity-10" />
      <div className="bubble-decoration bg-amber-500 w-48 h-48 -bottom-24 -right-24 opacity-10" />

      <div className="max-w-7xl mx-auto px-6 md:px-12 py-16 relative z-10">
        <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-10">
          {/* Brand */}
          <div className="space-y-4">
            <div className="flex items-center gap-3">
              <img src={LOGO_URL} alt="Winners Chapel Logo" className="h-12 w-12 object-contain" />
              <div>
                <p className="font-bold text-lg leading-tight">Winners Chapel</p>
                <p className="text-red-400 text-sm font-medium">International Ipswich</p>
              </div>
            </div>
            <p className="text-stone-400 text-sm leading-relaxed">
              Liberating the world through the preaching of the Word of Faith.
            </p>
            <div className="flex gap-3">
              {socials.map((s) => (
                <a
                  key={s.label}
                  href={s.href}
                  target="_blank"
                  rel="noopener noreferrer"
                  data-testid={`footer-social-${s.label.toLowerCase()}`}
                  className="p-2.5 rounded-full bg-stone-800 text-stone-400 hover:text-white hover:bg-red-600 transition-colors duration-200"
                  aria-label={s.label}
                >
                  <s.icon size={16} />
                </a>
              ))}
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h3 className="font-bold text-sm uppercase tracking-wider text-stone-400 mb-4">Quick Links</h3>
            <ul className="space-y-2.5">
              {quickLinks.map((link) => (
                <li key={link.href}>
                  <button
                    onClick={() => scrollTo(link.href)}
                    className="text-stone-300 hover:text-red-400 transition-colors text-sm"
                  >
                    {link.label}
                  </button>
                </li>
              ))}
            </ul>
          </div>

          {/* Service Times */}
          <div>
            <h3 className="font-bold text-sm uppercase tracking-wider text-stone-400 mb-4">Service Times</h3>
            <div className="space-y-3">
              <div className="flex items-start gap-2">
                <Clock size={14} className="mt-1 text-red-400 shrink-0" />
                <div>
                  <p className="text-sm font-semibold text-white">Sunday Service</p>
                  <p className="text-xs text-stone-400">10:00 AM</p>
                </div>
              </div>
              <div className="flex items-start gap-2">
                <Clock size={14} className="mt-1 text-amber-400 shrink-0" />
                <div>
                  <p className="text-sm font-semibold text-white">Wednesday Service</p>
                  <p className="text-xs text-stone-400">6:30 PM</p>
                </div>
              </div>
            </div>
          </div>

          {/* Contact */}
          <div>
            <h3 className="font-bold text-sm uppercase tracking-wider text-stone-400 mb-4">Location</h3>
            <div className="space-y-3">
              <div className="flex items-start gap-2">
                <MapPin size={14} className="mt-1 text-red-400 shrink-0" />
                <p className="text-sm text-stone-300">
                  Gainsborough Sports Centre<br />
                  5 Braziers Road<br />
                  Ipswich, IP3 0SP
                </p>
              </div>
            </div>
          </div>
        </div>

        {/* Bottom bar */}
        <div className="mt-12 pt-8 border-t border-stone-800 flex flex-col sm:flex-row justify-between items-center gap-4">
          <p className="text-xs text-stone-500">
            &copy; {new Date().getFullYear()} Winners Chapel International, Ipswich. All rights reserved.
          </p>
          <div className="flex items-center gap-4">
            <p className="text-xs text-stone-600">
              A branch of Winners Chapel International
            </p>
            <button
              onClick={onAdminClick}
              data-testid="footer-admin-btn"
              className="flex items-center gap-1.5 text-[10px] text-stone-600 hover:text-stone-400 transition-colors opacity-50 hover:opacity-100"
              aria-label="Admin access"
            >
              <Lock size={10} />
              Admin
            </button>
          </div>
        </div>
      </div>
    </footer>
  );
};
